import { Component } from '@angular/core';

@Component({
  selector: 'eiq-search-skeleton',
  templateUrl: 'search-skeleton.component.html',
  styleUrls: ['search-skeleton.component.scss']
})
export class SearchSkeletonComponent {}
